/*
  COTANTIN：装飾の動画（無音・ループ）を、画面に入ってから読み込んで再生する（2026-09-30 速度改善）。
  対象：<video data-ct-video data-hls="…m3u8" data-hls-lib="hls.light.min.js の URL" data-mp4="1080|url,">
  - 画面の 300px 手前で読み込みを始め、画面に入ったら再生、外れたら一時停止。
  - 画質：Shopify の HLS（1080p／720p／480p）で、表示の大きさと回線に合わせて自動で切り替える。
    Safari などは標準で再生。それ以外は hls.js をこのときだけ読み込む（他のページ・動画の無いページでは読まない）。
    HLS が使えないときは MP4。データセーバー・2G/3G でも HLS の最低画質から始まる。
  - 動きを減らす設定（prefers-reduced-motion）の端末では自動再生しない（ポスター画像のまま）。
*/
(() => {
  const videos = document.querySelectorAll('video[data-ct-video]');
  if (!videos.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let libPromise = null;

  const loadLib = (url) => {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (!libPromise) {
      libPromise = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = url;
        s.async = true;
        s.onload = () => (window.Hls ? resolve(window.Hls) : reject());
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return libPromise;
  };

  const mp4 = (video) => {
    const list = (video.dataset.mp4 || '').split(',').filter(Boolean)
      .map((s) => { const i = s.indexOf('|'); return { h: parseInt(s.slice(0, i), 10) || 0, url: s.slice(i + 1) }; })
      .sort((a, b) => a.h - b.h);
    return list.length ? list[list.length - 1].url : '';
  };

  const useMp4 = (video) => {
    const src = mp4(video);
    if (!src) return;
    video.preload = 'auto';
    video.src = src;
    if (video.dataset.ctWant) play(video);
  };

  const load = (video) => {
    if (video.dataset.ctLoaded) return;
    video.dataset.ctLoaded = '1';
    const hls = video.dataset.hls;
    if (hls && video.canPlayType('application/vnd.apple.mpegurl')) {
      video.preload = 'auto';
      video.src = hls;
      return;
    }
    if (hls && video.dataset.hlsLib && window.MediaSource) {
      loadLib(video.dataset.hlsLib).then((Hls) => {
        if (!Hls.isSupported()) return useMp4(video);
        const conn = navigator.connection || {};
        const slow = conn.saveData || /(^|-)2g$|^3g$/.test(conn.effectiveType || '');
        const h = new Hls({ capLevelToPlayerSize: true, startLevel: slow ? 0 : -1, maxBufferLength: 12, maxMaxBufferLength: 20 });
        h.on(Hls.Events.ERROR, (_e, data) => { if (data.fatal) { h.destroy(); useMp4(video); } });
        h.loadSource(hls);
        h.attachMedia(video);
        if (video.dataset.ctWant) play(video);
      }).catch(() => useMp4(video));
      return;
    }
    useMp4(video);
  };

  const play = (video) => {
    if (reduce) return;
    const p = video.play();
    if (p && p.catch) p.catch(() => {});
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach((v) => { v.dataset.ctWant = '1'; load(v); play(v); });
    return;
  }

  const near = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { load(e.target); near.unobserve(e.target); } });
  }, { rootMargin: '300px 0px' });

  const seen = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) { v.dataset.ctWant = '1'; load(v); play(v); }
      else { delete v.dataset.ctWant; if (!v.paused) v.pause(); }
    });
  }, { threshold: 0.25 });

  videos.forEach((v) => { near.observe(v); seen.observe(v); });
})();
